import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class PortalTypeService {
  isProjectPortal(portalType: string) : boolean {
    return portalType === 'project-portal';
  }

  getApprovalFunctionFromPortalType(portalType: string):number {
    return this.isProjectPortal(portalType) ? 2 : 1;
  }
}
